import { render, staticRenderFns } from "./Commit.vue?vue&type=template&id=785c65a3&"
import script from "./Commit.vue?vue&type=script&lang=js&"
export * from "./Commit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports